import { CheckCircle, Zap, Users, MessageSquare } from "lucide-react";
import { useTranslation } from 'react-i18next';

export const WhyTPSSection = () => {
  const { t } = useTranslation();

  return (
    <section id="why-tps" className="scroll-mt-20 pt-12 pb-6 bg-background" aria-labelledby="why-tps-heading">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Hero Section */}
          <div className="py-12 bg-primary text-white rounded-lg mb-10 px-6">
            <h2 id="why-tps-heading" className="text-2xl md:text-3xl font-bold text-center mb-6">
              {t('whyTPS.title')}
            </h2>
            <p className="text-sm text-center max-w-4xl mx-auto">
              {t('whyTPS.subtitle')}
            </p>
          </div>

          {/* Features Grid */}
          <div className="bg-[#448bcd] rounded-lg py-12 px-6">
            <div className="grid md:grid-cols-2 gap-12">
              <div className="text-white">
                <div className="flex items-center gap-3 mb-4">
                  <CheckCircle className="w-6 h-6" />
                  <h3 className="text-xl font-bold">{t('whyTPS.specialRequirements.title')}</h3>
                </div>
                <p className="text-sm leading-relaxed text-white/90">
                  {t('whyTPS.specialRequirements.description')}
                </p>
              </div>

              <div className="text-white">
                <div className="flex items-center gap-3 mb-4">
                  <Zap className="w-6 h-6" />
                  <h3 className="text-xl font-bold">{t('whyTPS.lightningFast.title')}</h3>
                </div>
                <p className="text-sm leading-relaxed text-white/90">
                  {t('whyTPS.lightningFast.description')}
                </p>
              </div>

              <div className="text-white">
                <div className="flex items-center gap-3 mb-4">
                  <Users className="w-6 h-6" />
                  <h3 className="text-xl font-bold">{t('whyTPS.weKnowYou.title')}</h3>
                </div>
                <p className="text-sm leading-relaxed text-white/90">
                  {t('whyTPS.weKnowYou.description')}
                </p>
              </div>

              <div className="text-white">
                <div className="flex items-center gap-3 mb-4">
                  <MessageSquare className="w-6 h-6" />
                  <h3 className="text-xl font-bold">{t('whyTPS.clearCommunication.title')}</h3>
                </div>
                <p className="text-sm leading-relaxed text-white/90">
                  {t('whyTPS.clearCommunication.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
